import RewardsPageController from './components/RewardsPageController';
import RewardsPageTextController from './components/RewardsPageTextController';

const RewardsHomepageOrganizer = () => {
    return (
        <div className='flex flex-col gap-3'>
            <RewardsPageController />
            <RewardsPageTextController
                screenName="marketplace"
            />
            <RewardsPageTextController
                screenName="plant_a_tree"
            />
            <RewardsPageTextController
                screenName="green_projects"
            />
        </div>
    );
}

export default RewardsHomepageOrganizer;